export type ConversationTabType = "ALL" | "ESCALATED" | "DONE";

export interface TabConfig {
  key: ConversationTabType;
  label: string;
  folder?: string;
  requiresFolderStatus?: boolean;
}

export const TAB_CONFIG: Record<ConversationTabType, TabConfig> = {
  ALL: {
    key: "ALL",
    label: "Tất cả",
    folder: undefined,
    requiresFolderStatus: false,
  },
  ESCALATED: {
    key: "ESCALATED",
    label: "Cần hỗ trợ",
    folder: "ESCALATED",
    requiresFolderStatus: true,
  },
  DONE: {
    key: "DONE",
    label: "Xong",
    folder: "DONE",
    requiresFolderStatus: true,
  },
};

export const ConversationTabHelpers = {
  getFolderForTab: (tab: ConversationTabType): string | undefined => {
    return TAB_CONFIG[tab]?.folder;
  },
  requiresFolderStatus: (tab: ConversationTabType): boolean => {
    return TAB_CONFIG[tab]?.requiresFolderStatus ?? false;
  },
  isFolderMatchingTab: (folder: string, tab: ConversationTabType): boolean => {
    const tabFolder = TAB_CONFIG[tab]?.folder;
    if (tab === "ALL") {
      return folder === "ALL" || !folder;
    }
    return folder === tabFolder;
  },
  getTabsWithFolderStatus: (): ConversationTabType[] => {
    return Object.values(TAB_CONFIG)
      .filter((config) => config.requiresFolderStatus)
      .map((config) => config.key);
  },
  isSpecialTab: (tab: ConversationTabType): boolean => {
    return tab !== "ALL";
  },
};
